import styled from 'styled-components'
import { COLORS } from 'utils'

export const Container = styled.div`
  width: 100vw;
  height: calc(100vh - 130px);

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const Card = styled.div`
  width: 100%;
  max-width: 506px;
  background: #fefefe;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.25);
`
export const HeaderCard = styled.div`
  background: ${COLORS.lightGray};
  height: 50px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 4px solid ${COLORS.black};
`
export const CardContent = styled.div`
  padding: 6%;
`
